import {
  requireNativeComponent,
  UIManager,
  Platform,
  ViewStyle,
} from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-chipmunk-gaode-map' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

type ChipmunkGaodeMapProps = {
  color: string;
  style: ViewStyle;
};

const ComponentName = 'ChipmunkGaodeMapView';

export const ChipmunkGaodeMapView =
  UIManager.getViewManagerConfig(ComponentName) != null
    ? requireNativeComponent<ChipmunkGaodeMapProps>(ComponentName)
    : () => {
        throw new Error(LINKING_ERROR);
      };
